import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DefinitionService {

  constructor(private http:HttpClient) { }
  list(){
    return this.http.get(`${environment.endpoint}/definitions`)
  }
  updateIndex(service:any){
    return this.http.post(`${environment.endpoint}/definition/index/update`,service)
  }
  update(service:any){
    console.log(service)
    const form:FormData = new FormData();
    for (const [key, value] of Object.entries(service)) {
      if(value!=null)
        if(key==`image`){
          form.append(`image`,service.image)
        }
        else{
          form.append(key,`${value}`)
        }

    }

    return this.http.post(`${environment.endpoint}/definition/update`,form)
  }
  add(service:any){
    console.log(service)
    const form:FormData = new FormData();
    for (const [key, value] of Object.entries(service)) {
      if(value!=null)
        if(key==`image`){
          form.append(`image`,service.image)
        }else{
          form.append(key,`${value}`)
        }

    }

    return this.http.post(`${environment.endpoint}/definition/create`,form)
  }
  delete(service_id){
    return this.http.delete(`${environment.endpoint}/definition/delete?definition_id=${service_id}`)
  }
}
